import { ApartmentCardController as ApartmentCard } from './apartmentCardController/apartmentCard.controller';

export default ApartmentCard;
